import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
type Props = {
    onclick?: any;
    isAimlMenu?: boolean;
};
const MenuLeftPanel: React.FC<Props> = ({ onclick, isAimlMenu = false }) => {
    return (
        <li className="hidden owner-box lg:block">
            <div className="consultationbox smheight py-10 px-[25px] bg-primary-500 text-white dark:text-light h-full">
                <div className="mb-2.5">
                    <Image
                        alt="Jaiinam Shahh"
                        src="/img/img-jainam-shah-2x.webp"
                        height="150"
                        width="150"
                        className="mx-auto"
                        loading="lazy"
                    />
                </div>
                <p className="mb-2.5 fw-700 text-white">Get Free Consultation</p>
                <p className="mb-2.5 fs-md text-white">
                    Have an idea? Let&apos;s collaborate to make your dream digital solution a reality!
                </p>
                {isAimlMenu && (
                    <Link
                        href={'/ai-ml-development-services'}
                        onClick={onclick}
                        className="btn btn-gradient-b w-full mb-2.5 drop-shadow-md"
                    >
                        Explore AI/ML Services
                    </Link>
                )}
                <Link
                    href={'/contact-us'}
                    onClick={onclick}
                    className="inline-block mb-0 w-full bg-white border-white btn btn-white text-blue hover:bg-blue hover:text-white"
                >
                    Contact Us
                </Link>
            </div>
        </li>
    );
};

export default MenuLeftPanel;
